import { render, staticRenderFns } from "./BrickBasicSettings.vue?vue&type=template&id=0878755a&scoped=true&"
import script from "./BrickBasicSettings.vue?vue&type=script&lang=js&"
export * from "./BrickBasicSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrickBasicSettings.vue?vue&type=style&index=0&id=0878755a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878755a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0878755a')) {
      api.createRecord('0878755a', component.options)
    } else {
      api.reload('0878755a', component.options)
    }
    module.hot.accept("./BrickBasicSettings.vue?vue&type=template&id=0878755a&scoped=true&", function () {
      api.rerender('0878755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickBasicSettings.vue"
export default component.exports